import { Squares } from "@kit/ui/squares-background"
import { cn } from "@kit/ui/utils"
import { useEffect, useState } from "react"

export function BackgroundSquares({
  className,
}: {
  className?: string
}) {
  const [squareSize, setSquareSize] = useState(70)
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < 640) {
        setSquareSize(40)
      } else {
        setSquareSize(70)
      }
    }
    onResize()
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])
  return (
    <div className={cn(
      'relative h-[647px] md:h-[800px] xl:h-[1060px] w-full',
      className,
    )}>
      <Squares
        squareSize={squareSize}
        borderColor="rgba(255, 255, 255, 0.10)"
        hoverFillColor="rgba(255, 255, 255, 0.03)"
      />
    </div>
  )
}